<div class="toast-msg-conatiner" *ngIf="showNotification">
  <div
    class="toast-msg"
    [ngStyle]="{
      'background-color': notificationTypeError ? '#f54b4b' : '#73d76a',
    }"
    >{{ notificationMsg }}</div>
</div>

<div id="main">
  <div
    class="toolbar-container"
    style="box-shadow: none; background-color: #eaf1f5"
  >
    <div class="" style="box-shadow: 0px 4px 4px #0000001f">
      <!-- SEARCH -->
      <div *ngIf="is_openSearch" class="bg-white border-top">
        <div class="input-wrap" style="display: inline-block">
          <form [formGroup]="searchForm">
            <div
              class="d-flex m-3"
              style="
                color: #bababa;
                border: 1px solid #e2e1ea;
                border-radius: 10px;
                height: 50px;
              "
            >
              <div style="width: 40px">
                <span class="wraped-input-icon">
                  <span class="material-icons-outlined"> search </span>
                </span>
              </div>
              <div style="flex-grow: 1">
                <input
                  formControlName="search"
                  style="
                    height: 100%;
                    width: 100%;
                    box-shadow: none !important;
                    border: none;
                    background-color: transparent;
                  "
                  type="text"
                  placeholder="Search"
                />
              </div>
              <div class="d-flex" style="width: 50px">
                <div
                  *ngIf="isSearchActive"
                  class="spinner-border m-auto"
                  role="status"
                  style="width: 1.5rem; height: 1.5rem"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- SERVICE PRODUCT LIST -->
  <div style="margin-top: 2px">
    <div data-preserve-scroll infinite-scroll [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle" (scrolled)="onScroll($event)"
      (scrolledUp)="onUp($event)" [scrollWindow]="false" style="overflow-y: auto; height: calc(100vh - 56px)">
      <ng-container *ngIf="loading; else realContent">
        <div
          class="serviceItem d-flex p-2 my-3"
          *ngFor="let _ of [].constructor(5)"
        >
          <div class="mr-2">
            <div
              class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
              style="width: 80px; height: 90px"
            >
              <div class="skeleton-text very-short mb-1"></div>
              <div class="d-flex align-items-center">
                <div class="skeleton-text very-short"></div>
              </div>
            </div>
          </div>
          <div class="row no-gutters w-100" style="overflow: hidden">
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="d-flex flex-column w-75">
                <div class="skeleton-text short mb-1"></div>
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>
              <div class="d-flex flex-column align-items-end w-25">
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short mb-1"></div>
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #realContent>
        <div
          *ngIf="list_array.length === 0"
          class="no-data-message text-center empty-container"
        >
          <span>No product list data found.</span>
          <span *ngIf="selectedCat == 0">Click "+ Add" to add products.</span>
        </div>

        <ng-container *ngIf="list_array.length > 0">
          <div
            class="item-container-base w-100 d-flex"
            *ngFor="let item of list_array; trackBy: trackByProductId"
          >
            <div class="item-container w-100 d-flex">
              <div
                (click)="goToProductDetails(item.ID)"
                class="item-img p-2 d-flex flex-column align-items-center position-relative"
              >
                <div class="image-container">
                  <img
                    class="image my-auto"
                    [src]="item.Image"
                    (error)="onImageError($event)"
                    style="
                      object-fit: contain;
                      max-width: 80px;
                      max-height: 60px;
                    "
                  />

                  <div *ngIf="!item.IsProductPublish" class="unpublished-label">
                    Unpublished
                  </div>
                </div>

                <span
                  class="stock-count px-1 rounded mt-auto"
                  [ngStyle]="
                    item.OutOfStock || (item.Stock < 1 && item.AutoOutOfStock)
                      ? { 'background-color': '#ffcdd2', color: '#ca4343' }
                      : { 'background-color': '#c8e6c9', color: '#316a35' }
                  "
                >
                  {{
                    item.OutOfStock || (item.Stock < 1 && item.AutoOutOfStock)
                      ? "Out of stock"
                      : "In stock"
                  }}
                </span>
              </div>

              <div
                class="item-details-container d-flex flex-column flex-fill py-2 pr-2"
              >
                <div class="d-flex justify-content-between">
                  <div
                    class="d-flex flex-column item-details"
                    (click)="goToProductDetails(item.ID)"
                  >
                    <div class="item-name">
                      <span
                        *ngIf="item.IsDummy"
                        class="dummy mr-1 px-1 text-center"
                        style="width: fit-content; height: fit-content"
                      >
                        Dummy
                      </span>
                      {{ item.ProductName }}
                    </div>

                    <div class="item-category">
                      {{ item.CategoryName }}
                    </div>
                  </div>
                </div>

                <div
                  class="item-pricing d-flex justify-content-between mt-auto"
                >
                  <div
                    class="flex-fill d-flex"
                    (click)="goToProductDetails(item.ID)"
                  >
                    <div
                      style="width: 130px"
                      class="d-flex flex-column mt-auto"
                    >
                      <div
                        *ngIf="item?.sizeValue"
                        style="
                          font-size: clamp(9px, 3.6vw, 12px);
                          margin-bottom: -4px;
                        "
                      >
                        Size:
                        <span style="color: #000">
                          {{ item.sizeValue }}
                        </span>
                      </div>

                      <div style="font-size: clamp(9px, 3.6vw, 12px)">
                        Stock:
                        <span style="color: #000">
                          {{ item.Stock }}
                        </span>
                      </div>

                      <div
                        class="d-flex flex-column"
                        style="
                          font-size: clamp(10px, 4.2vw, 15px);
                          font-weight: 500;
                          white-space: nowrap;
                          overflow: hidden;
                        "
                      >
                        <div *ngIf="item.MRP > item.FinalPrice" class="mrp">
                          {{ item.MRP | currency: "INR" : "symbol" : "1.0-0" }}
                        </div>

                        <div class="d-flex align-items-center">
                          <span
                            class="unit-price"
                            style="max-width: 60%; font-weight: 600"
                          >
                            {{
                              item.FinalPrice
                                | currency: "INR" : "symbol" : "1.0-0"
                            }}
                          </span>

                          <span
                            *ngIf="adminService.getProductDiscount(item)"
                            class="offer-percentage ml-auto ml-3"
                          >
                            {{
                              adminService.getProductDiscount(item)
                                | number: "1.0-0"
                            }}% Off
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-column align-items-end">
                    <button
                      disabled
                      class="edit-btn"
                      (click)="showDeletePopup(item)"
                      style="border: 1px solid #dc3545; color: #dc3545"
                    >
                      <i class="material-icons">delete</i>
                      <span>Delete</span>
                    </button>

                    <button
                      class="edit-btn mt-1"
                      disabled
                      (click)="goToEdit(item)"
                      style="border: 1px solid #6c757d; color: #6c757d"
                    >
                      <i class="material-icons">edit</i>
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>

    <div
      class="d-flex justify-content-center align-items-center py-4 text-secondary"
      *ngIf="list_array?.length > 0"
    >
      {{ list_array?.length }} products listed
    </div>
  </div>
</div>
